module.exports = __webpack_public_path__ + "img/map-report-usage-guide-click.982856d1.png";